import { TextInput, TextInputProps } from "@mantine/core";
import { PatternFormat } from "react-number-format";

interface CnpjInputProperties extends Omit<TextInputProps, "value" | "defaultValue" | "type"> {
  value?: string | number | null;
  defaultValue?: string | number | null;
}

const CNPJInput = (properties: CnpjInputProperties) => {
  return <PatternFormat customInput={TextInput} type="text" format="##.###.###.####-##" {...properties} />;
};

export default CNPJInput;
